<template>
    <div class="order-detail-container">
        <!-- 面包屑导航 -->
        <div class="breadcrumb-container">
            <el-breadcrumb separator=" > ">
                <el-breadcrumb-item>查询订单</el-breadcrumb-item>
                <el-breadcrumb-item>订单详情</el-breadcrumb-item>
            </el-breadcrumb>
            <el-button type="text" class="back-button" @click="handleBack">
                <i class="el-icon-arrow-left"></i> 返回
            </el-button>
        </div>
        <!-- 订单详情主体 -->
        <el-card class="order-detail-card">
            <!-- 订单编号 -->
            <div class="order-number">订单编号：{{ orderDetail.order_sn }} </div>
            <!-- 物流时间线 -->
            <el-timeline>
                <el-timeline-item v-for="(item, index) in orderDetail.record" :key="index"
                    :timestamp="item.orderrecord_opera_time" :status="index == 0 ? 'success' : 'primary'"
                    placement="top">
                    <div>
                        <div class="status-text">{{ item.orderrecord_r_type_name }}</div>
                        <div class="description-text">{{ item.orderrecord_remark }}</div>
                        <!-- 签收图片 -->
                        <div
                            v-if="orderDetail.sign_imgs && orderDetail.sign_imgs.length > 0 && item.orderrecord_r_type == '5'">
                            <div class="image-title">签收单照片</div>
                            <div class="images-container">
                                <el-image v-for="(image, imgIndex) in orderDetail.sign_imgs" :key="imgIndex"
                                    :src="image" :preview-src-list="orderDetail.sign_imgs" class="logistics-image">
                                    <div slot="error" class="image-error">
                                        <i class="el-icon-picture-outline"></i>
                                    </div>
                                </el-image>
                            </div>
                            <div class="image-title">回单照片</div>
                            <div class="images-container">
                                <el-image v-for="(image, imgIndex) in orderDetail.huidan_imgs" :key="imgIndex"
                                    :src="image" :preview-src-list="orderDetail.huidan_imgs" class="logistics-image">
                                    <div slot="error" class="image-error">
                                        <i class="el-icon-picture-outline"></i>
                                    </div>
                                </el-image>
                            </div>
                        </div>
                    </div>
                </el-timeline-item>
            </el-timeline>
        </el-card>
    </div>
</template>

<script>
import { getOrderDetail } from '@/api/home.js'
export default {
    name: 'OrderDetail',
    data() {
        return {
            aid: '',
            order_sn: '',
            // 订单详情数据
            orderDetail: {

            }
        }
    },
    mounted() {
        this.aid = this.$route.query.aid;
        this.getOrderDetail();
    },
    methods: {
        getOrderDetail() {
            getOrderDetail({
                aid: this.aid
            }).then(res => {
                if (res.code == 1) {
                    this.orderDetail = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            })
        },
        // 返回上一页
        handleBack() {
            // 优先使用浏览器历史记录返回，触发keep-alive缓存
            if (window.history.length > 1) {
                window.history.back();
            } else {
                // 如果没有历史记录，则使用replace方法避免增加新的历史记录
                this.$router.replace('/order-query');
            }
        }
    }
}
</script>

<style scoped>
.order-detail-container {
    max-width: 1200px;
    margin: 0 auto;
    background-color: #f5f7fa;
    min-height: 100vh;
    padding: 20px;
}

/* 面包屑导航 */
.breadcrumb-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

.back-button {
    color: #409EFF;
}

/* 订单详情卡片 */
.order-detail-card {
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

/* 订单编号 */
.order-number {
    font-size: 16px;
    font-weight: 500;
    color: #303133;
    margin-bottom: 30px;
    padding-bottom: 15px;
    border-bottom: 1px solid #ebeef5;
}

/* 时间线样式 */
.el-timeline {
    padding-left: 20px;
}



.status-text {
    font-size: 14px;
    font-weight: 500;
    color: #666666;
    margin-bottom: 5px;
}

.description-text {
    font-size: 14px;
    color: #999;
}

/* 图片容器 */
.image-title {
    font-size: 12px;
    font-weight: 500;
    color: #777777;
    margin-top: 5px;
}

.images-container {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-top: 10px;
}

.logistics-image {
    width: 80px;
    height: 80px;
    border-radius: 4px;
    cursor: pointer;
    object-fit: cover;
}

/* 图片错误占位符 */
.image-error {
    width: 80px;
    height: 80px;
    background-color: #f5f7fa;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #c0c4cc;
}
.el-timeline >>> .el-timeline-item:first-child .el-timeline-item__node {
    background-color: #0066FF !important;
    border-color: #0066FF !important;
}
</style>